<h2 mat-dialog-title>Create Insurance Contact</h2>
<div mat-dialog-content>
  <p>You need to create an insurance contact before you can add insurance policies.</p>
  
  <form [formGroup]="contactForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="first_name" required>
      <mat-hint>Enter insured first name</mat-hint>
      @if (contactForm.get('first_name')?.hasError('required')) {
        <mat-error>
          First name is required
        </mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="last_name" required>
      <mat-hint>Enter insured last name</mat-hint>
      @if (contactForm.get('last_name')?.hasError('required')) {
        <mat-error>
          Last name is required
        </mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Organization (Optional)</mat-label>
      <input matInput formControlName="organization">
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="onSubmit()" 
    [disabled]="contactForm.invalid">
    <span>Create Contact</span>
  </button>
</div>
